import React, {useEffect, useState} from "react";
import "./Login.css";
import axios from "axios";
import {useHistory} from "react-router-dom";
import {toast} from "react-toastify";
import localStorage from "redux-persist/es/storage";


const Login = () => {
    const history = useHistory();
    const [otp1, setOtp1] = useState("");
    const [otp2, setOtp2] = useState("");
    const [otp3, setOtp3] = useState("");
    const [otp4, setOtp4] = useState("");
    const [isError, setIserror] = useState('');
    const [show, setShow] = useState('hide');
    const [showResendMsg, setResendMsgShow] = useState('show');
    const [error, setErr] = useState("");
    const [roles, setRoles]= useState([])
    const [selectedRole, setSelectedRole] = useState('')
    const [errorMsg, setErrorMsg] = useState('OTP does not exist.')

    // If user is logged in automatically redirected to dashboard page
    useEffect( () => {
        const token = !!window.localStorage.token;
        const email = localStorage.getItem("userId");
        if (token === true && localStorage.getItem("token") !== undefined && localStorage.getItem("token") !== null && localStorage.getItem("token") !==''){
            history.push('/dashboard');
        }

        setTimeout(() => {
            setResendMsgShow('hide')
        }, 3000);
        const userRoles = window.localStorage.user_roles
        if(userRoles !== undefined && userRoles !== null && userRoles !== ''){
            let roleUserResponse = JSON.parse(userRoles)
            if (Object.keys(roleUserResponse).length > 0) {
                setRoles(roleUserResponse)
                if(roleUserResponse[0] !== undefined){
                    setSelectedRole(roleUserResponse[0]?.id)
                }
            }
        }
    }, []);

    //Login function

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        if (otp1 === "" || otp2 === "" || otp3 === "" || otp4 === "") {
            setErr('red');
            return false;
        } else {
            var otp = otp1 + otp2 + otp3 + otp4;
        }
        if(selectedRole === ''){
            toast.error("Please select role")
            return false
        }
        //Try to login
        if (otp) {
            var config = {headers: {"Content-Type": "application/json"}};
            const base_url = process.env.REACT_APP_API_URL;
            const response = await axios.post(
                base_url + `/api/v1/login`,
                {
                    email: window.localStorage.userId,
                    otp: parseInt(otp),
                    roleId:selectedRole,
                    fusionState:window.localStorage.fusionState,
                    source:'leadx'
                },
                config,
            );

            if (response.data.status === true) {
                let webView = window.localStorage.webview
                if(webView !== undefined && webView == 'true' && response?.data?.response?.data?.leadx_login_preference === 1){
                    setShow('show');
                    setResendMsgShow('hide')
                    setErr('red');
                    setTimeout(() => {
                        setShow('hide');
                    }, 3000);
                    setErrorMsg('Your are now allowed to login from app');
                } else if(!webView && parseInt(response?.data?.response?.data?.leadx_login_preference) === 2) {
                    setShow('show');
                    setResendMsgShow('hide')
                    setErr('red');
                    setTimeout(() => {
                        setShow('hide');
                    }, 3000);
                    setErrorMsg('Your are now allowed to login from browser');
                }
                else {
                    localStorage.setItem("token", response?.data?.response?.data?.token);
                    localStorage.setItem("name", response?.data?.response?.data?.name);
                    localStorage.setItem("user_id", response?.data?.response?.data?.id);
                    localStorage.setItem("active_page", 'home');
                    localStorage.setItem("role_id", selectedRole);
                    localStorage.setItem("refresh_token", response?.data?.response?.data?.refresh_token);
                    localStorage.setItem("login_preference", response?.data?.response?.data?.leadx_login_preference);
                    delete window.localStorage.user_roles

                    // handleUserProfile()

                    if (response?.data?.response?.data?.token) {
                        window.localStorage.previous_url = JSON.stringify({0: window.location.href});
                        history.push('/home');
                    }
                }


            } else {
                setShow('show');
                setResendMsgShow('hide')
                setErr('red');
                setTimeout(() => {
                    setShow('hide');
                }, 3000);
                setErrorMsg(response?.data?.message)
            }
        } else {
            if (otp === '') {
                setIserror('This field is mandatory');
            } else setIserror('Invalid OTP ');
        }
    };


    const handleUserProfile = async () => {
        var config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem("token")
            }

        };
        const base_url = process.env.REACT_APP_API_URL;
        const user_id = localStorage.getItem("user_id");
        const {data} = await axios.get(
            base_url + `/api/v1/getProfile?roleId=` + user_id,
            config
        );

        if(data.response.status === false || data?.message === "TOKEN_EXPIRED"){
            delete localStorage.clear()
            window.location.href="/"
        }
        if (data.response.data) {
            localStorage.setItem("user_profile", JSON.stringify(data?.response?.data));
            // localStorage.setItem("role_id", JSON.stringify(data?.response?.data?.roles[0]?.pivot?.role_id));
        }
    }

    const handleChangeInput = (e) => {
        const {maxLength, value, name} = e.target;
        const [fieldName, fieldIndex] = name.split("-");

        let fieldIntIndex = parseInt(fieldIndex, 10);

        if (value.length >= maxLength) {

            // It should not be last input field
            if (fieldIntIndex < 4) {

                // Get the next input field using its name
                const nextfield = document.querySelector(
                    `input[name=field-${fieldIntIndex + 1}]`
                );

                // If found, focus the next field
                if (nextfield !== null) {
                    nextfield.focus();
                }
            }
        }
    }

    const handleResentOtp = async(e) => {
        e.preventDefault();
        var config = { headers: { "Content-Type": "application/json"} };
        const base_url = process.env.REACT_APP_API_URL;
        const response  = await axios.post(
            base_url+`/api/v1/generateOTP`,
            {
                email:  window.localStorage.userId,
            },
            config,
        );

        if(response.data.status === true )
        {
            setResendMsgShow('show')
            setShow('hide');
            setTimeout(() => {
                setResendMsgShow('hide')
            }, 3000);
            window.localStorage.fusionState = response?.data?.response?.data?.state
        }else{
            setIserror('Failed to send OTP');
            setShow('show');
            setResendMsgShow('hide')
            setTimeout(() => {
                setShow('hide')
            }, 3000);
        }
    }
    return (
        <>
            {/*<div className="login">              */}
            {/*      <i className="fa fa-user icon"></i>*/}
            {/*      <input type="text" onChange={(e) => setEmail(e.target.value)} value={email}  placeholder="Username" />*/}
            {/*        <input type="password" onChange={(e) => setPassword(e.target.value)} value={password} placeholder="Password"/>*/}
            {/*        <button onClick={handleLogin} className="btn btn-primary btn-block btn-large">LOGIN</button>   */}
            {/*</div>      */}
            <div className="login-page-bg">
                <div className="wrapper mt-login-35">
                    <div className="row justify-content-center">
                        <div className="col-xl-10 col-lg-12 col-md-9">
                            <div className="card o-hidden border-0 shadow-lg my-5">
                                <div className="card-body p-0">
                                    <div className="row h-68vh">
                                        <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                                        <div className="col-lg-6">
                                            <div className="p-5">
                                                <div className="text-center">
                                                    <img className="" src="./img/login_logo.png" alt=""/>
                                                    <h2 id="blast" className="f-size colorful-text">LeadX</h2>
                                                    {/*<h1 className="h4 text-gray-900 mb-4">Welcome Back!</h1>*/}
                                                    <p className={`green ${showResendMsg}`} >4 Digit OTP has been sent to your Mobile.</p>

                                                </div>
                                                <form className="user" onSubmit={handleSubmit}>
                                                    {/* <input type="number" className="form-control form-control-user"
                                                           id="otp"  required
                                                           maxLength="4"
                                                           placeholder="0"
                                                           value={otp}
                                                           onChange={(e) => setOtp(e.target.value.trim())}
                                                    /> */}
                                                    {roles.length > 1 &&
                                                        <div className="col-md-12 mb-3">
                                                            <select className="select_role" onChange={(e) => {setSelectedRole(e.target.value)}} required>
                                                                <option value="" selected>Select Your Role</option>
                                                                {roles.map((val, i) => {
                                                                    return (
                                                                        <option value={val.id}>{val.name}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                        </div>
                                                    }

                                                    {roles.length === 1 &&
                                                        <div className="col-md-12">
                                                            <select className="select_role" onChange={(e) => {setSelectedRole(e.target.value)}} required>
                                                                {roles.map((val, i) => {
                                                                    return (
                                                                        <>
                                                                            {/*{setSelectedRole(val.id)}*/}
                                                                            <option value={val.id} selected>{val.name}</option>
                                                                        </>
                                                                    )
                                                                })}
                                                            </select>
                                                        </div>
                                                    }

                                                    <div className="col-md-12 d-flex l-2">
                                                        <div className="col-md-3">
                                                            <input type="number"
                                                                   className={`form-control form-control-user login-otp ${error}`}
                                                                   id="otp1" required
                                                                   maxLength="1"
                                                                   placeholder="0"
                                                                   value={otp1}
                                                                   onChange={(e) => {
                                                                       setOtp1(e.target.value.trim())
                                                                       handleChangeInput(e)
                                                                   }}
                                                                   name="field-1"
                                                            />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <input type="number"
                                                                   className={`form-control form-control-user login-otp ${error}`}
                                                                   id="otp2" required
                                                                   maxLength="1"
                                                                   placeholder="0"
                                                                   value={otp2}
                                                                   onChange={(e) => {
                                                                       setOtp2(e.target.value.trim())
                                                                       handleChangeInput(e)
                                                                   }}
                                                                   name="field-2"
                                                            />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <input type="number"
                                                                   className={`form-control form-control-user login-otp ${error}`}
                                                                   id="otp3" required
                                                                   maxLength="1"
                                                                   placeholder="0"
                                                                   value={otp3}
                                                                   onChange={(e) => {
                                                                       setOtp3(e.target.value.trim())
                                                                       handleChangeInput(e)
                                                                   }}
                                                                   name="field-3"
                                                            />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <input type="number"
                                                                   className={`form-control form-control-user login-otp ${error}`}
                                                                   id="otp4" required
                                                                   maxLength="1"
                                                                   placeholder="0"
                                                                   value={otp4}
                                                                   onChange={(e) => {
                                                                       setOtp4(e.target.value.trim())
                                                                       handleChangeInput(e)
                                                                   }}
                                                                   name="field-4"
                                                            />
                                                        </div>
                                                    </div>

                                                    <span className={`otp-error ${show}`}>{errorMsg}</span>
                                                    <div className="col-md-12 l-2 text-center">
                                                        <span >OTP not received? <a href={"login-otp"} onClick={(e) => handleResentOtp(e)}>resend</a></span>
                                                    </div>

                                                    <button type="submit" id=""
                                                            className="btn btn-primary btn-user btn-block">
                                                        Log In
                                                    </button>

                                                </form>
                                                <hr/>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}

export default Login